// extracted by mini-css-extract-plugin
module.exports = {"textArea":"style-module__textArea___hqCMc"};